import React from "react";
import FrontBodyPart from "./FrontBodyPart";
import BackBodyPart from "./BackBodyPart";

const BodyViewer = ({
  isFront = true,
  frontPreview,
  backPreview,
  onClickBodyParts,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  return (
    <div className="common-front-trigger">
      {isFront ? (
        <div className="common-front-trigger-inner">
          <FrontBodyPart
            frontBodyPartValue={frontPreview}
            onClickBodyParts={onClickBodyParts}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
          />
        </div>
      ) : (
        <div className="common-front-trigger-inner">
          <BackBodyPart
            backBodyPartValue={backPreview}
            onClickBodyParts={onClickBodyParts}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
          />
        </div>
      )}
    </div>
  );
};

export default BodyViewer;
